import actions from './actions';

const {
  LIST_ESQUEMAS_CONTRACTUALES, 
  LIST_ESQUEMAS_CONTRACTUALES_SELECTBOX,
  CREATE_ESQUEMAS_CONTRACTUALES,
  READ_ESQUEMAS_CONTRACTUALES,
  UPDATE_ESQUEMAS_CONTRACTUALES,    
} = actions;

const initialState = {
  data: [],
  dataSelectBox: [],
  record: {},   
};


const esquemasContractualesCrudReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_ESQUEMAS_CONTRACTUALES:
      return {
        ...state,
        data: data
      }
    case LIST_ESQUEMAS_CONTRACTUALES_SELECTBOX:
      return {
        ...state,
        dataSelectBox: data
      }
    case CREATE_ESQUEMAS_CONTRACTUALES:
      return {
        ...state,
        record: data
      }
    case READ_ESQUEMAS_CONTRACTUALES:
      return {
        ...state,
        record: data
      }
    case UPDATE_ESQUEMAS_CONTRACTUALES:
      return {
        ...state,
        record: data
      }
    default:
      return state;
  }
};


export default esquemasContractualesCrudReducer;
